export default __webpack_public_path__ + "static/media/WhatsApp Image 2026-01-14 at 6.28.09 PM.e8c946bc.jpeg";